import React from "react";

import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import { RegionalBlocksProvider } from "../../context/RegionalBlocksContext";

export const RegionalBlocks = () => {
  return (
    <RegionalBlocksProvider>
      <Overview />
    </RegionalBlocksProvider>
  );
};

export const AddRegionalBlocks = () => {
  return (
    <RegionalBlocksProvider>
      <Add />
    </RegionalBlocksProvider>
  );
};

export const EditRegionalBlocks = () => {
  return (
    <RegionalBlocksProvider>
      <Edit />
    </RegionalBlocksProvider>
  );
};
